// extracted by mini-css-extract-plugin
module.exports = {"main":"Error404Page_main__2OcYE"};